var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"about"},[(_vm.selectedCat)?_c('img',{attrs:{"src":_vm.selectedCat.url}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }